(function () {
  'use strict';
  var root = document.getElementById('rs-quiz');
  if (!root) return;

  var NW = '__nw';
  var BUNDLE_PCT = parseInt(root.dataset.bundlePct, 10) || 10;
  var BUNDLE_MIN = parseInt(root.dataset.bundleMin, 10) || 3;
  var KLAVIYO = root.dataset.klaviyo || '';

  var LABELS = {
    drzewne:'Drzewny', kwiatowe:'Kwiatowy', orientalne:'Orientalny', swieze:'Świeży',
    cytrusowe:'Cytrusowy', gourmand:'Słodki', aromatyczne:'Aromatyczny',
    wiosna:'Wiosna', lato:'Lato', jesien:'Jesień', zima:'Zima',
    codzien:'Na co dzień', biuro:'Do biura', wieczor:'Na wieczór',
    randka:'Na randkę', specjalna:'Na okazje',
    meski:'Męski', damski:'Damski', uniseks:'Uniseks'
  };
  var FAM_WORD = {drzewne:'Drzewny',kwiatowe:'Kwiatowy',orientalne:'Ciepły',swieze:'Świeży',
    cytrusowe:'Cytrusowy',gourmand:'Słodki',aromatyczne:'Zielny'};
  var OCC_WORD = {codzien:'codzienny',biuro:'biurowy',wieczor:'wieczorowy',
    randka:'zmysłowy',specjalna:'odświętny'};
  var INTENSITY_DESC = {1:'Bardzo dyskretny',2:'Dyskretny',3:'Wyważony',4:'Wyraźny',5:'Dominujący'};
  var INTENSITY_HINT = {
    1:'Czuje go tylko osoba blisko Ciebie.',
    2:'Zostaje przy Tobie, nie wchodzi innym w drogę.',
    3:'Wyczuwalny w rozmowie, bez przesady.',
    4:'Zauważalny, gdy wchodzisz do pomieszczenia.',
    5:'Zostawia ślad na długo po wyjściu.'
  };

  var STEPS = [
    { key:'gender', type:'single', q:'Dla kogo szukasz zapachu?',
      helper:'Od tego zaczynamy, żeby zawęzić katalog',
      opts:[['meski','Dla mężczyzny'],['damski','Dla kobiety'],['uniseks','Uniseks']] },
    { key:'families', type:'multi', max:3, q:'Jaki klimat lubisz najbardziej?',
      helper:'Wybierz do 3 opcji',
      opts:['drzewne','kwiatowe','orientalne','swieze','cytrusowe','gourmand','aromatyczne'] },
    { key:'seasons', type:'multi', max:2, q:'Na jaką porę roku?',
      helper:'Wybierz do 2 opcji', opts:['wiosna','lato','jesien','zima'] },
    { key:'occasions', type:'multi', max:2, q:'Kiedy chcesz go nosić?',
      helper:'Wybierz do 2 opcji', opts:['codzien','biuro','wieczor','randka','specjalna'] },
    { key:'intensity', type:'slider', q:'Jak mocno ma być czuć?',
      helper:'Nie chodzi o jakość, tylko o to, ile miejsca ma zajmować' },
    { key:'longevity', type:'single', q:'Jak ważna jest dla Ciebie trwałość?',
      helper:'Wybierz jedną',
      opts:[['2','Wolę lekkie, mogę poprawić w ciągu dnia'],
            ['3','Średnia trwałość mi wystarczy'],
            ['5','Ma trzymać cały dzień, to dla mnie kluczowe']] },
    { key:'likes', type:'text', q:'Jakie zapachy już lubisz?',
      helper:'Wpisz nazwy, a poszukamy podobnych. Możesz pominąć' }
  ];

  // karty edukacyjne — wyświetlane PO wskazanym kroku
  var FACTS = {
    1: { t:'Rodzina zapachowa to nie wszystko',
         d:'Ten sam „drzewny" może być suchy i chłodny albo ciepły i kremowy. Dlatego pytamy dalej o porę roku i moc, a nie tylko o klimat.' },
    3: { t:'Trwałość zależy od zapachu, nie od nas',
         d:'Odlewki przelewamy z oryginalnych flakonów, bez rozcieńczania. Jeśli EDT trzyma 4 godziny, tyle samo trzyma w 3 ml i w pełnym flakonie.' },
    5: { t:'Dlatego warto zacząć od małej pojemności',
         d:'Zapach na blotterze i na skórze to dwie różne rzeczy. Za 3 ml sprawdzisz to u siebie, zanim wydasz kilkaset złotych na flakon.' }
  };

  var state = { screen:'intro', step:0, fact:null,
    a:{gender:null,families:[],seasons:[],occasions:[],intensity:3,longevity:null,likes:''},
    results:[], sizes:{}, products:null };

  function el(h){var d=document.createElement('div');d.innerHTML=h.trim();return d.firstChild;}
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function zl(g){return (g/100).toFixed(2).replace('.',',')+' zł';}
  function tagVal(t,p){var o=[];for(var i=0;i<t.length;i++)if(t[i].indexOf(p)===0)o.push(t[i].slice(p.length));return o;}

  function loadProducts(){
    if(state.products) return Promise.resolve(state.products);
    return fetch(root.dataset.feed || '/pages/quiz-feed')
      .then(function(r){return r.text();})
      .then(function(txt){
        var raw = JSON.parse(txt.slice(txt.indexOf('['), txt.lastIndexOf(']')+1));
        state.products = raw.map(function(p){
          var t=p.tags||[];
          return {h:p.h,t:p.t,b:p.b,img:p.img,v:p.v,
            families:tagVal(t,'fam:'), seasons:tagVal(t,'sezon:'),
            occasions:tagVal(t,'okazja:'), notes:tagVal(t,'nuta:'),
            intensity:parseInt(tagVal(t,'moc:')[0],10)||3,
            longevity:parseInt(tagVal(t,'trwalosc:')[0],10)||3,
            gender:tagVal(t,'profil:')[0]||'uniseks',
            search:((p.t||'')+' '+(p.b||'')).toLowerCase()};
        }).filter(function(p){return p.families.length && p.v.length;});
        return state.products;
      });
  }

  function overlap(pk,has){if(!pk.length)return 0;var h=0;for(var i=0;i<pk.length;i++)if(has.indexOf(pk[i])>-1)h++;return h/pk.length;}

  // dopasowanie po nazwach z pola "jakie zapachy lubisz"
  function likedProfile(txt){
    if(!txt||txt.trim().length<3) return null;
    var q=txt.toLowerCase().replace(/[^a-ząćęłńóśźż0-9\s]/g,' ');
    var words=q.split(/\s+/).filter(function(w){return w.length>3;});
    if(!words.length) return null;
    var hits=state.products.filter(function(p){
      var c=0; words.forEach(function(w){if(p.search.indexOf(w)>-1)c++;});
      return c>=1;
    });
    if(!hits.length) return null;
    var fam={},sum=0;
    hits.forEach(function(p){p.families.forEach(function(f){fam[f]=(fam[f]||0)+1;sum++;});});
    return {fam:fam,sum:sum,handles:hits.map(function(p){return p.h;})};
  }

  function score(p,a,lp){
    var fam=a.families.filter(function(x){return x!==NW;});
    var sea=a.seasons.filter(function(x){return x!==NW;});
    var occ=a.occasions.filter(function(x){return x!==NW;});
    var got=0,max=0;
    if(fam.length){got+=3*overlap(fam,p.families);max+=3;}
    if(sea.length){got+=2*overlap(sea,p.seasons);max+=2;}
    if(occ.length){got+=2*overlap(occ,p.occasions);max+=2;}
    got+=Math.max(0,1.5-Math.abs(p.intensity-a.intensity)*0.4);max+=1.5;
    if(a.longevity&&a.longevity!==NW){got+=Math.max(0,1-Math.abs(p.longevity-Number(a.longevity))*0.25);max+=1;}
    if(lp){
      var s=0;p.families.forEach(function(f){if(lp.fam[f])s+=lp.fam[f]/lp.sum;});
      got+=Math.min(2,s*2);max+=2;
    }
    var pct=max===0?60:Math.round(got/max*100);
    return {raw:got,pct:Math.max(38,Math.min(99,pct))};
  }

  function rank(a){
    var lp=likedProfile(a.likes);
    var pool=state.products;
    if(a.gender&&a.gender!==NW){
      var f=pool.filter(function(p){return p.gender===a.gender||p.gender==='uniseks';});
      if(f.length>=3) pool=f;
    }
    if(lp) pool=pool.filter(function(p){return lp.handles.indexOf(p.h)===-1;});
    return pool.map(function(p){var s=score(p,a,lp);return {p:p,raw:s.raw,pct:s.pct};})
      .sort(function(x,y){return y.raw-x.raw;}).slice(0,3);
  }

  function profileTitle(a){
    var w=[];
    var fam=a.families.filter(function(x){return x!==NW;});
    if(fam[0]) w.push(FAM_WORD[fam[0]]||'Zrównoważony');
    var occ=a.occasions.filter(function(x){return x!==NW;});
    if(occ[0]&&OCC_WORD[occ[0]]) w.push(OCC_WORD[occ[0]]);
    w.push(a.intensity>=4?'wyrazisty':a.intensity<=2?'dyskretny':'wyważony');
    return w.slice(0,3).join(', ');
  }

  function reasonFor(p,a){
    var parts=[];
    var fam=a.families.filter(function(x){return x!==NW;}).filter(function(f){return p.families.indexOf(f)>-1;})[0];
    var sea=a.seasons.filter(function(x){return x!==NW;}).filter(function(s){return p.seasons.indexOf(s)>-1;})[0];
    if(fam) parts.push('trafia w klimat '+(LABELS[fam]||fam).toLowerCase());
    if(sea) parts.push('sprawdza się na '+(LABELS[sea]||sea).toLowerCase());
    if(p.intensity>=4) parts.push('zostawia wyraźny ślad');
    else if(p.intensity<=2) parts.push('trzyma się blisko skóry');
    if(!parts.length) parts.push('pasuje do Twojego profilu');
    return parts.join(', ')+'.';
  }

  function addToCart(items){
    return fetch('/cart/add.js',{method:'POST',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({items:items})
    }).then(function(r){
      if(!r.ok) return r.json().then(function(e){throw new Error(e.description||'Błąd');});
      return r.json();
    }).then(function(d){
      document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
      var dr=document.querySelector('cart-drawer');
      if(dr&&typeof dr.open==='function') dr.open();
      else if(window.Rebuy&&window.Rebuy.SmartCart) window.Rebuy.SmartCart.show();
      return d;
    });
  }

  function variantFor(p,ml){
    for(var i=0;i<p.v.length;i++)
      if(p.v[i].ml.replace(/\s/g,'')===ml+'ml'&&p.v[i].ok) return p.v[i];
    return null;
  }

  /* --- zapis / odtworzenie wyniku z URL --- */
  function encodeState(){
    var a=state.a;
    return btoa(unescape(encodeURIComponent(JSON.stringify([
      a.gender,a.families,a.seasons,a.occasions,a.intensity,a.longevity,a.likes
    ])))).replace(/=+$/,'');
  }
  function decodeState(s){
    try{
      var d=JSON.parse(decodeURIComponent(escape(atob(s))));
      return {gender:d[0],families:d[1]||[],seasons:d[2]||[],occasions:d[3]||[],
        intensity:d[4]||3,longevity:d[5],likes:d[6]||''};
    }catch(e){return null;}
  }
  function pushURL(){
    try{history.replaceState(null,'',location.pathname+'?p='+encodeState());}catch(e){}
  }

  function render(){
    root.dataset.align=(state.screen==='intro'||state.screen==='loading')?'center':'top';
    root.innerHTML='';
    if(state.screen==='intro') return root.appendChild(viewIntro());
    if(state.screen==='loading') return root.appendChild(viewLoading());
    if(state.screen==='results') return root.appendChild(viewResults());
    if(state.screen==='fact') return root.appendChild(viewFact());
    root.appendChild(viewStep());
  }

  function viewIntro(){
    var n=el(
      '<div class="rsq-col rsq-intro rsq-anim-in">'+
      '<p class="rsq-eyebrow">DEKANTY PERFUM</p>'+
      '<h1 class="rsq-serif">Znajdź swój zapach<br>w 7 pytaniach</h1>'+
      '<p class="rsq-muted">Odpowiadasz na kilka krótkich pytań, a my dobieramy trzy perfumy z naszego katalogu. Każdy możesz przetestować w małej pojemności, zanim zdecydujesz się na flakon.</p>'+
      '<div class="rsq-stats"><div class="rsq-stat">60 sekund</div>'+
      '<div class="rsq-stat">3 propozycje</div>'+
      '<div class="rsq-stat">Testujesz od 3 ml</div></div>'+
      '<hr class="rsq-divider">'+
      '<button type="button" class="rsq-btn" style="margin-top:32px">Rozpocznij quiz</button>'+
      '<p class="rsq-muted rsq-fine">Wynik dostaniesz od razu. Będziesz mógł zapisać go linkiem lub wysłać sobie na maila.</p>'+
      '</div>');
    n.querySelector('button').addEventListener('click',function(){
      loadProducts(); state.screen='step'; state.step=0; render();
    });
    return n;
  }

  function viewFact(){
    var f=FACTS[state.fact];
    var n=el('<div class="rsq-col rsq-factcard rsq-anim-in">'+
      '<p class="rsq-eyebrow">CZY WIESZ, ŻE</p>'+
      '<h2 class="rsq-serif">'+esc(f.t)+'</h2>'+
      '<p>'+esc(f.d)+'</p>'+
      '<button type="button" class="rsq-btn">Jedziemy dalej</button></div>');
    n.querySelector('button').addEventListener('click',function(){
      state.screen='step'; state.step++; state.fact=null; render(); scrollTop();
    });
    return n;
  }

  function scrollTop(){
    var y=root.getBoundingClientRect().top+window.pageYOffset-10;
    window.scrollTo({top:y<0?0:y,behavior:'smooth'});
  }

  function viewStep(){
    var s=STEPS[state.step], a=state.a;
    var wrap=el('<div class="rsq-col rsq-step rsq-anim-in"></div>');
    var pct=Math.round(state.step/STEPS.length*100);
    wrap.appendChild(el('<div class="rsq-bar"><div class="rsq-krok">KROK '+(state.step+1)+' Z '+STEPS.length+
      '</div><div class="rsq-track"><div class="rsq-fill" style="width:'+pct+'%"></div></div></div>'));

    if(state.step>0){
      var back=el('<button type="button" class="rsq-link rsq-back">← Wróć</button>');
      back.addEventListener('click',function(){state.step--;render();});
      wrap.appendChild(back);
    }
    wrap.appendChild(el('<h2 class="rsq-question rsq-serif">'+esc(s.q)+'</h2>'));
    wrap.appendChild(el('<p class="rsq-helper">'+esc(s.helper)+'</p>'));

    if(s.type==='slider'){
      var sw=el('<div class="rsq-slider-wrap">'+
        '<div class="rsq-slider-value rsq-serif">'+a.intensity+'</div>'+
        '<div class="rsq-slider-desc">'+INTENSITY_DESC[a.intensity]+'</div>'+
        '<div class="rsq-slider-hint">'+INTENSITY_HINT[a.intensity]+'</div>'+
        '<input type="range" min="1" max="5" step="1" class="rsq-slider" value="'+a.intensity+'">'+
        '<div class="rsq-slider-labels"><span>Dyskretny</span><span>Wyrazisty</span></div></div>');
      sw.querySelector('input').addEventListener('input',function(e){
        a.intensity=Number(e.target.value);
        sw.querySelector('.rsq-slider-value').textContent=a.intensity;
        sw.querySelector('.rsq-slider-desc').textContent=INTENSITY_DESC[a.intensity];
        sw.querySelector('.rsq-slider-hint').textContent=INTENSITY_HINT[a.intensity];
      });
      wrap.appendChild(sw);
      wrap.appendChild(nextBtn('Dalej'));
      return wrap;
    }

    if(s.type==='text'){
      var tw=el('<div><textarea class="rsq-textarea" rows="3" placeholder="np. Sauvage, Aventus, Baccarat Rouge 540"></textarea>'+
        '<p class="rsq-helper" style="margin-top:8px">Szukamy w naszym katalogu i dobieramy zapachy z podobnym profilem.</p></div>');
      var ta=tw.querySelector('textarea');
      ta.value=a.likes;
      ta.addEventListener('input',function(){a.likes=ta.value;});
      wrap.appendChild(tw);
      wrap.appendChild(nextBtn('Pokaż wyniki'));
      var skip=el('<button type="button" class="rsq-link rsq-link-center" style="margin-top:10px">Pomiń</button>');
      skip.addEventListener('click',function(){a.likes='';finish();});
      wrap.appendChild(skip);
      return wrap;
    }

    var isMulti=s.type==='multi';
    var cur=isMulti?a[s.key]:(a[s.key]===null?[]:[a[s.key]]);
    if(isMulti) wrap.appendChild(el('<div class="rsq-counter">'+
      cur.filter(function(x){return x!==NW;}).length+' / '+s.max+'</div>'));

    var list=el('<div class="rsq-options"></div>');
    var atMax=isMulti&&cur.filter(function(x){return x!==NW;}).length>=s.max;
    s.opts.forEach(function(o){
      var val=Array.isArray(o)?o[0]:o;
      var lab=Array.isArray(o)?o[1]:(LABELS[o]||o);
      var sel=cur.indexOf(val)>-1, dim=atMax&&!sel;
      var b=el('<button type="button" class="rsq-option" data-selected="'+sel+'" data-dim="'+dim+'">'+
        '<span>'+esc(lab)+'</span><span class="rsq-check">'+(sel?'✓':'')+'</span></button>');
      b.addEventListener('click',function(){pick(s,val);});
      list.appendChild(b);
    });
    if(s.key!=='gender'){
      var nw=el('<button type="button" class="rsq-option rsq-option-nw" data-selected="'+(cur.indexOf(NW)>-1)+'">'+
        '<span>Nie wiem / bez znaczenia</span><span class="rsq-check"></span></button>');
      nw.addEventListener('click',function(){pick(s,NW);});
      list.appendChild(nw);
    }
    wrap.appendChild(list);
    if(isMulti) wrap.appendChild(nextBtn('Dalej',cur.length===0));
    return wrap;
  }

  function pick(s,val){
    var a=state.a;
    if(s.type==='multi'){
      var arr=a[s.key];
      if(val===NW){a[s.key]=[NW];advance();return;}
      arr=arr.filter(function(x){return x!==NW;});
      var i=arr.indexOf(val);
      if(i>-1) arr.splice(i,1); else if(arr.length<s.max) arr.push(val);
      a[s.key]=arr; render();
    } else { a[s.key]=val; render(); setTimeout(advance,220); }
  }

  function nextBtn(label,disabled){
    var b=el('<div class="rsq-actions"><button type="button" class="rsq-btn"'+
      (disabled?' disabled':'')+'>'+esc(label)+'</button></div>');
    b.querySelector('button').addEventListener('click',advance);
    return b;
  }

  function advance(){
    if(state.step>=STEPS.length-1) return finish();
    if(FACTS[state.step]){ state.fact=state.step; state.screen='fact'; render(); scrollTop(); return; }
    state.step++; render(); scrollTop();
  }

  function finish(){
    state.screen='loading'; render(); scrollTop();
    Promise.all([loadProducts(),new Promise(function(r){setTimeout(r,1400);})])
      .then(function(){
        state.results=rank(state.a);
        state.sizes={};
        state.results.forEach(function(r){state.sizes[r.p.h]='5';});
        state.screen='results'; render(); pushURL(); scrollTop();
      })
      .catch(function(){
        root.innerHTML='<div class="rsq-col rsq-loading"><p>Nie udało się wczytać produktów. Odśwież stronę.</p></div>';
      });
  }

  function viewLoading(){
    return el('<div class="rsq-col rsq-loading rsq-anim-in">'+
      '<div class="rsq-sweep"><span></span></div>'+
      '<p>Dobieramy Twoje zapachy…</p></div>');
  }

  function viewResults(){
    var a=state.a;
    var wrap=el('<div class="rsq-col rsq-results rsq-anim-in"></div>');
    wrap.appendChild(el('<p class="rsq-eyebrow">TWÓJ PROFIL</p>'));
    wrap.appendChild(el('<h1 class="rsq-serif">'+esc(profileTitle(a))+'</h1>'));

    var chips=el('<div class="rsq-chips" style="margin-top:14px"></div>');
    [].concat([a.gender],a.families,a.seasons,a.occasions)
      .filter(function(x){return x&&x!==NW;})
      .forEach(function(v){chips.appendChild(el('<span class="rsq-chip rsq-chip-static">'+esc(LABELS[v]||v)+'</span>'));});
    chips.appendChild(el('<span class="rsq-chip rsq-chip-static">'+esc(INTENSITY_DESC[a.intensity])+'</span>'));
    wrap.appendChild(chips);

    var cards=el('<div class="rsq-cards"></div>');
    state.results.forEach(function(r,i){cards.appendChild(cardFor(r,i,a));});
    wrap.appendChild(cards);

    wrap.appendChild(bundleBlock());
    wrap.appendChild(saveBlock());

    var again=el('<button type="button" class="rsq-link rsq-link-center rsq-restart">Zacznij od nowa</button>');
    again.addEventListener('click',function(){
      state.a={gender:null,families:[],seasons:[],occasions:[],intensity:3,longevity:null,likes:''};
      state.screen='intro'; state.step=0;
      try{history.replaceState(null,'',location.pathname);}catch(e){}
      render(); scrollTop();
    });
    wrap.appendChild(again);
    return wrap;
  }

  function cardFor(r,i,a){
    var p=r.p;
    var card=el('<div class="rsq-card"></div>');
    card.appendChild(el('<div class="rsq-card-top"><span class="rsq-rank rsq-serif">0'+(i+1)+'</span>'+
      '<span class="rsq-badge">'+r.pct+'% dopasowania</span></div>'));
    card.appendChild(el(p.img
      ?'<a class="rsq-thumb" href="/products/'+esc(p.h)+'"><img src="'+esc(p.img)+'" alt="'+esc(p.t)+'" loading="lazy"></a>'
      :'<div class="rsq-thumb"><span>'+esc(p.t)+'</span></div>'));
    card.appendChild(el('<a class="rsq-name rsq-serif" href="/products/'+esc(p.h)+'">'+esc(p.t)+'</a>'));
    card.appendChild(el('<p class="rsq-brand">'+esc(p.b)+'</p>'));
    card.appendChild(el('<p class="rsq-reason">'+esc(reasonFor(p,a))+'</p>'));

    var nc=el('<div class="rsq-chips"></div>');
    p.notes.slice(0,3).forEach(function(n){
      nc.appendChild(el('<span class="rsq-chip">'+esc(n.replace(/-/g,' '))+'</span>'));
    });
    card.appendChild(nc);

    var sizes=el('<div class="rsq-sizes"></div>');
    var priceEl=el('<div class="rsq-price rsq-serif"></div>');
    function paint(){
      var ml=state.sizes[p.h];
      Array.prototype.forEach.call(sizes.children,function(b){b.dataset.selected=(b.dataset.ml===ml);});
      var v=variantFor(p,ml);
      priceEl.textContent=v?zl(v.p):'Niedostępne';
    }
    ['3','5','10','20'].forEach(function(ml){
      var v=variantFor(p,ml);
      var b=el('<button type="button" class="rsq-size" data-ml="'+ml+'"'+(v?'':' disabled')+'>'+ml+' ml</button>');
      if(v) b.addEventListener('click',function(){state.sizes[p.h]=ml;paint();});
      sizes.appendChild(b);
    });
    card.appendChild(sizes);
    card.appendChild(priceEl);

    var btn=el('<button type="button" class="rsq-btn">Dodaj do koszyka</button>');
    btn.addEventListener('click',function(){
      var v=variantFor(p,state.sizes[p.h]);
      if(!v) return;
      btn.disabled=true;btn.textContent='Dodaję…';
      addToCart([{id:v.id,quantity:1,properties:{_quiz:'1'}}])
        .then(function(){btn.textContent='Dodano ✓';})
        .catch(function(){btn.textContent='Spróbuj ponownie';btn.disabled=false;});
    });
    card.appendChild(btn);
    paint();
    return card;
  }

  function bundleBlock(){
    var vs=state.results.map(function(r){return variantFor(r.p,'3');}).filter(Boolean);
    if(vs.length<BUNDLE_MIN) return document.createDocumentFragment();
    var sum=vs.reduce(function(s,v){return s+v.p;},0);
    var after=Math.round(sum*(100-BUNDLE_PCT)/100);
    var n=el('<div class="rsq-bundle">'+
      '<p class="rsq-eyebrow">NAJCZĘŚCIEJ WYBIERANE</p>'+
      '<h3 class="rsq-serif">Weź całą trójkę w 3 ml</h3>'+
      '<p>Przetestuj wszystkie trzy na własnej skórze, zanim zdecydujesz się na większą pojemność. Rabat '+BUNDLE_PCT+'% nalicza się automatycznie w koszyku, bez kodu.</p>'+
      '<div class="rsq-bundle-price"><s>'+zl(sum)+'</s><strong>'+zl(after)+'</strong></div>'+
      '<button type="button" class="rsq-btn rsq-btn-gold">Dodaj zestaw do koszyka</button></div>');
    n.querySelector('button').addEventListener('click',function(){
      var b=n.querySelector('button');
      b.disabled=true;b.textContent='Dodaję…';
      addToCart(vs.map(function(v){return {id:v.id,quantity:1,properties:{_quiz:'bundle'}};}))
        .then(function(){b.textContent='Dodano ✓';})
        .catch(function(){b.textContent='Spróbuj ponownie';b.disabled=false;});
    });
    return n;
  }

  function saveBlock(){
    var n=el('<div class="rsq-email">'+
      '<h4 class="rsq-serif">Zapisz swój wynik</h4>'+
      '<p>Skopiuj link i wróć do niego, kiedy chcesz. Twoje propozycje się nie zgubią.</p>'+
      '<button type="button" class="rsq-btn rsq-copy">Skopiuj link do wyniku</button>'+
      (KLAVIYO?'<div class="rsq-sep"></div>'+
        '<p>Albo wyślemy Ci go na maila razem z pełnym opisem dopasowania.</p>'+
        '<input type="email" class="rsq-input" placeholder="twoj@email.pl" autocomplete="email">'+
        '<button type="button" class="rsq-btn rsq-send">Wyślij mi wynik</button>':'')+
      '</div>');

    n.querySelector('.rsq-copy').addEventListener('click',function(){
      var b=n.querySelector('.rsq-copy');
      var url=location.origin+location.pathname+'?p='+encodeState();
      var done=function(){b.textContent='Skopiowano ✓';setTimeout(function(){b.textContent='Skopiuj link do wyniku';},2500);};
      if(navigator.clipboard) navigator.clipboard.writeText(url).then(done).catch(done);
      else {var t=document.createElement('textarea');t.value=url;document.body.appendChild(t);t.select();document.execCommand('copy');t.remove();done();}
    });

    var send=n.querySelector('.rsq-send');
    if(send) send.addEventListener('click',function(){
      var inp=n.querySelector('input');
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(inp.value)){inp.focus();return;}
      send.disabled=true;send.textContent='Wysyłam…';
      var a=state.a;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+KLAVIYO,{
        method:'POST',headers:{'Content-Type':'application/json',revision:'2024-10-15'},
        body:JSON.stringify({data:{type:'subscription',attributes:{profile:{data:{type:'profile',
          attributes:{email:inp.value,properties:{
            quiz_gender:a.gender, quiz_families:a.families, quiz_seasons:a.seasons,
            quiz_occasions:a.occasions, quiz_intensity:a.intensity, quiz_longevity:a.longevity,
            quiz_likes:a.likes,
            quiz_top_1:state.results[0]?state.results[0].p.h:'',
            quiz_top_2:state.results[1]?state.results[1].p.h:'',
            quiz_top_3:state.results[2]?state.results[2].p.h:'',
            quiz_url:location.origin+location.pathname+'?p='+encodeState(),
            quiz_completed_at:new Date().toISOString()}}}},
          relationships:{list:{data:{type:'list',id:root.dataset.klaviyoList}}}}}})
      }).then(function(){
        n.innerHTML='<h4 class="rsq-serif">Wysłane ✓</h4><p>Sprawdź skrzynkę, wynik jest już w drodze.</p>';
      }).catch(function(){send.textContent='Spróbuj ponownie';send.disabled=false;});
    });
    return n;
  }

  // odtworzenie wyniku z linku
  var m=location.search.match(/[?&]p=([^&]+)/);
  if(m){
    var restored=decodeState(m[1]);
    if(restored){
      state.a=restored;
      state.screen='loading'; render();
      Promise.all([loadProducts(),new Promise(function(r){setTimeout(r,600);})]).then(function(){
        state.results=rank(state.a);
        state.sizes={};
        state.results.forEach(function(r){state.sizes[r.p.h]='5';});
        state.screen='results'; render();
      }).catch(function(){state.screen='intro';render();});
    } else render();
  } else render();
})();